export class PresOffresFNS {

	public autorisee: string;

	public exigee: string;

	public interdite: string;

	constructor() { 
		 		this.autorisee = '';
		this.exigee = '';
		this.interdite = '';
 
	}
}
